export function replaceTemplateString(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{([^}]+)\}/g, (match, key) => (values[key] !== undefined ? String(values[key]) : match));
}
